export default class Debug{
    isActive=false;

    static print(...any){
        if (this.isActive)
             Debug.print(...any);
    }
}